fragment AccordionFragment on accordion_Entry {
  typeHandle
  heading
  body
}
